import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import Button from "react-bootstrap-button-loader";
import _ from "lodash";
import { BASE_IMAGES_URL, COMMON_FAIL_MESSAGE } from "Constants";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import {
  saveCourse,
  deleteInstructor,
  addInstructor,
  fetchAllUnpublishedCourses,
  fetchAllCoursesNames,
} from "CourseAction";
import { fetchEventDetails } from "DashboardUserAction";
import { showError, showSuccess } from "ReduxErrorBar";
import ImageCropper from "ImageCropper";
import VideoUploader from "VideoUploader";
import LocaleStrings from "Languages";

class AddCourse extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount() {
    this.props.fetchEventDetails(this.props.session);
  }

  afterSubmit = (courseid) => {
    let { session, callfrom } = this.props;

    this.setState({ loading: false });
    this.props.fetchAllUnpublishedCourses(session, courseid);
    this.props.fetchAllCoursesNames(session);

    if (callfrom === "courses_list") {
      this.props.finishOperationsCallback();
    }
  };

  onSubmitForm = (data) => {
    let { session, editMode, initialValues } = this.props;


    var values = { ...data };
    if (data.tagid) {
      if (
        data.tagid != "" &&
        Array.isArray(data.tagid) &&
        data.tagid.length > 0
      ) {
        let tags = _.map(data.tagid, (el) => el.value);
        values.tagid = tags.join(",");
      } else if (data.tagid != "" && !Array.isArray(data.tagid)) {
        values.tagid = data.tagid;
      }
    }


    this.setState({ loading: true });
    this.props.saveCourse(session, values, (response) => {

      if (response.success) {
        var courseid = response.data.resource[0].courseid;
        // If edit, then do required action on instructors
        if (editMode) {
          // Check if any course mentioned or not
          if (!_.isEmpty(data.courseteachers)) {
            // Check if new instructor added.
            if (
              Array.isArray(data.courseteachers) &&
              data.courseteachers.length > 0
            ) {
              let instructorArr = [];
              _.map(data.courseteachers, (item) => {
                let obj = {
                  eventid: session.eventid,
                  speakerid: item.value,
                  courseid: courseid,
                };
                instructorArr.push(obj);
              });

              // Check if course have any instructor already
              if (initialValues.sessionspeakers_by_courseid.length > 0) {
                // If course edit action, then delete the old instructor and add new
                this.props.deleteInstructor(session, values, (resdel) => {
                  if (resdel.success) {
                    this.props.addInstructor(session, instructorArr, (res) => {
                      this.afterSubmit(courseid);

                      if (res.success) {
       
                        this.props.showSuccess(
                          LocaleStrings.course_form_basic_details_save_success
                        );
                      } else {
                       
                        this.props.showError(
                          LocaleStrings.course_form_basic_details_save_warning_instructor_not_saved
                        );
                      }
                    });
                  } else {
          
                    this.props.showError(
                      LocaleStrings.course_form_basic_details_save_warning_instructor_not_saved
                    );
                  }
                });
              } else {
                this.props.addInstructor(session, instructorArr, (res) => {
                  this.afterSubmit(courseid);

                  if (res.success) {
     
                    this.props.showSuccess(
                      LocaleStrings.course_form_basic_details_save_success
                    );
                  } else {
            
                    this.props.showError(
                      LocaleStrings.course_form_basic_details_save_warning_instructor_not_saved
                    );
                  }
                });
              }
            } else {
              this.afterSubmit(courseid);
         
              this.props.showSuccess(
                LocaleStrings.course_form_basic_details_save_success
              );
            }
          } else {
            // Check if course have any instructor already
            if (initialValues.sessionspeakers_by_courseid.length > 0) {
              this.props.deleteInstructor(session, values, (resdel) => {
                this.afterSubmit(courseid);

                if (resdel.success) {
          
                  this.props.showSuccess(
                    LocaleStrings.course_form_basic_details_save_success
                  );
                } else {
       
                  this.props.showError(
                    LocaleStrings.course_form_basic_details_save_warning_instructor_not_saved
                  );
                }
              });
            } else {
              this.afterSubmit(courseid);
        
              this.props.showSuccess(
                LocaleStrings.course_form_basic_details_save_success
              );
            }
          }
        } else {
          // Check if instructor added.
          if (
            data.courseteachers &&
            Array.isArray(data.courseteachers) &&
            data.courseteachers.length > 0
          ) {
            let instructorArr = [];
            _.map(data.courseteachers, (item) => {
              let obj = {
                eventid: session.eventid,
                speakerid: item.value,
                courseid: response.data.resource[0].courseid,
              };
              instructorArr.push(obj);
            });

            this.props.addInstructor(session, instructorArr, (res) => {
              this.afterSubmit(courseid);

              if (res.success) {

                this.props.showSuccess(
                  LocaleStrings.course_form_basic_details_save_success
                );
              } else {
 
                this.props.showError(
                  LocaleStrings.course_form_basic_details_save_warning_instructor_not_saved
                );
              }
            });
          } else {
            this.afterSubmit(courseid);
     
            this.props.showSuccess(
              LocaleStrings.course_form_basic_details_save_success
            );
          }
        }
      } else {
        this.setState({ loading: false });
       
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      initialValues,
      editMode,
    } = this.props;
 

    return (
      <div className="course-details">
        <form onSubmit={handleSubmit(this.onSubmitForm)}>
          <AddCourseForm {...this.props} />

          <div className="mt-30">
            <Button
              className="btn btn-custom-blue"
              loading={this.state.loading}
              disabled={pristine || invalid || submitting}
              type="submit"
            >
              {LocaleStrings.button_save}
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var edit = false;
  var initVals = { isprivate: "0" };
  if (
    state.allUnpublishedCourseList &&
    state.allUnpublishedCourseList.count > 0
  ) {
    edit = true;
    initVals = state.allUnpublishedCourseList.resource[0];
    initVals.coverimagehidden =
      state.allUnpublishedCourseList.resource[0].coverimage;
    initVals.covervideohidden =
      state.allUnpublishedCourseList.resource[0].covervideo;
    initVals.isprivate =
      state.allUnpublishedCourseList.resource[0].isprivate == true ? "1" : "0";

    let instructorsArr = _.map(
      state.allUnpublishedCourseList.resource[0].sessionspeakers_by_courseid,
      (el) => el.speakerid
    );
    initVals.courseteachers = instructorsArr.join(",");
  }


  return {
    session: state.session,
    editMode: edit,
    initialValues: initVals,
    allSpeakers: state.allSpeakers,
    interests: state.interests,
    allCourseName: state.allCourseName,
  };
}

function validate(values, ownProps) {


  var errors = {};
  var coursename = values["coursename"];
  var description = values["description"];
  var coverimagehidden = values["coverimagehidden"];
  var covervideohidden = values["covervideohidden"];

  if (!coverimagehidden || coverimagehidden == "") {
    errors["coverimagehidden"] = LocaleStrings.course_form_validation_required;
  }
  if (!covervideohidden || covervideohidden == "") {
    errors["covervideohidden"] = LocaleStrings.course_form_validation_required;
  }

  if (!coursename || coursename.trim() === "") {
    errors["coursename"] = LocaleStrings.course_form_validation_required;
  } else if (
    coursename &&
    ownProps.editMode &&
    coursename != ownProps.initialValues.coursename &&
    _.filter(ownProps.allCourseName.resource, (obj) => {
      return obj.coursename == coursename;
    }).length > 0
  ) {
    errors["coursename"] =
      LocaleStrings.course_form_validation_course_already_exist;
  } else if (
    coursename &&
    !ownProps.editMode &&
    _.filter(ownProps.allCourseName.resource, (obj) => {
      return obj.coursename == coursename;
    }).length > 0
  ) {
    errors["coursename"] =
      LocaleStrings.course_form_validation_course_already_exist;
  }

  if (!description || description.trim() === "") {
    errors["description"] = LocaleStrings.course_form_validation_required;
  }

  return errors;
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchEventDetails,
  saveCourse,
  deleteInstructor,
  addInstructor,
  fetchAllUnpublishedCourses,
  fetchAllCoursesNames,
})(
  reduxForm({
    validate,
    form: "CourseForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(AddCourse)
);

class AddCourseForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { imagePreviewUrl: "", videoData: {} };


  }

  onImageSave = (img) => {
    this.setState({ imagePreviewUrl: img == "" ? "removed" : img });
    this.props.autofill("coverimagehidden", img);
  };

  onImageChange = (imageAvailable) => {};

  onFilesDrop = (data) => {
    this.setState({ videoData: data == "" ? "removed" : data });
    this.props.autofill("covervideohidden", data);
  };

  onFileAvailable = (changed) => {};

  render() {
    let { session, editMode, initialValues, allSpeakers, interests } =
      this.props;
    let { imagePreviewUrl, videoData } = this.state;
    let teachers = [];
    let tags = [];

    if (allSpeakers && allSpeakers.data) {
      _.map(allSpeakers.data, (item, index) => {
        let obj = {
          name: `${item.firstname} ${item.lastname}`,
          value: item.speakerid.toString(),
        };

        teachers.push(obj);
      });
    }
    if (interests) {
      _.map(interests, (item, index) => {
        let obj = {
          name: `${item.interest}`,
          value: item.interestid.toString(),
        };

        tags.push(obj);
      });
    }

    let tempImage = "";
    let tempVideo = {};
    if (editMode) {
      // Checking cover videos
      if (initialValues.coverimage && initialValues.covervideo) {
        let file = initialValues.covervideo;
        let original = file.split("/").pop();
        let fileName = original;
        let fileObj = { file: file, filename: fileName };

        tempImage = `${BASE_IMAGES_URL}/${initialValues.coverimage}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
        tempVideo = fileObj;
      } else if (initialValues.coverimage && !initialValues.covervideo) {
        tempImage = `${BASE_IMAGES_URL}/${initialValues.coverimage}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
        tempVideo = {};
      } else if (!initialValues.coverimage && initialValues.covervideo) {
        let file = initialValues.covervideo;
        let original = file.split("/").pop();
        let fileName = original;
        let fileObj = { file: file, filename: fileName };

        tempImage = "";
        tempVideo = fileObj;
      }
    }

    if (imagePreviewUrl == "") {
      imagePreviewUrl = tempImage;
    } else if (imagePreviewUrl == "removed") {
      imagePreviewUrl = "";
    }

    if (_.isEmpty(videoData)) {
      videoData = tempVideo;
    } else if (videoData == "removed") {
      videoData = {};
    }

    let fileOld = true;
    let filePreview = "";
    let fileName = "";
    if (videoData && videoData.file) {
      var file = videoData.file;
      fileName = videoData.filename;
      filePreview = `${BASE_IMAGES_URL}/${file}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
      fileOld = true;
      var n = file.search(";base64,");
      if (n > 0) {
        fileOld = false;
        filePreview = file;
      }
    }

    return (
      <div className="basicform">
        <div className="form-group">
          <div className="row">
            <div className="col-md-4">
              <label className="control-label-top">
                {LocaleStrings.course_form_label_course_cover_image}
                <span className="label-mandatory">*</span>
              </label>
              <ImageCropper
                displaySize={{ width: 270, height: 270 }} // For image display style
                requiredSize={{ width: 500, height: 500 }} // For image size required validation
                cropperSize={{ width: 170, height: 170 }} // Cropper display size. Note its add 50px for padding
                border={10}
                onImageSave={this.onImageSave}
                onImageChange={this.onImageChange}
                imagepath={imagePreviewUrl}
                imageType="jpg"
                ref={this.cropperRef}
                className="drop-zone-area-custom-image"
                insideImage="../../style/images/dummy-image-fill@3x.png"
                insideImageStyle={{
                  width: 36,
                  height: 36,
                }}
                insideText="Drag and Drop or Click here to upload image. Image size must be 500x500 px."
              />
              <Field
                name="coverimagehidden"
                type="text"
                component={this.renderHiddenFieldText}
                bsClass="mt-10"
              />
            </div>
            <div className="col-md-8">
              <label className="control-label-top">
                {LocaleStrings.course_form_label_course_cover_video}
                <span className="label-mandatory">*</span>
              </label>
              <VideoUploader
                displaySize={{ width: 540, height: 270 }} // For video display style
                width={200}
                height={200}
                onFileSave={this.onFilesDrop}
                onFileChnageLocally={this.onFileAvailable}
                filepath={filePreview}
                fileName={fileName}
                fileOld={fileOld}
                className="drop-zone-area-custom-video"
                insideImage="../../style/images/dummy-video-fill@3x.png"
                insideImageStyle={{
                  width: 36,
                  height: 25,
                }}
                insideText="Drag and Drop or Click here to upload video."
              />
              <Field
                name="covervideohidden"
                type="text"
                component={this.renderHiddenFieldText}
                bsClass="mt-10"
              />
            </div>
          </div>
        </div>
        <Field
          name="coursename"
          label={LocaleStrings.course_form_label_course_name}
          placeholder={LocaleStrings.course_form_ph_course_name}
          type="text"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="description"
          label={LocaleStrings.course_form_label_course_description}
          placeholder={LocaleStrings.course_form_ph_course_description}
          type="text"
          component={this.renderFieldTextarea}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
        />
        <div className="row form-group">
          <div className="col-sm-12">
            <label className="control-label-top">
              {LocaleStrings.course_form_label_course_listing}
              <span className="label-mandatory">*</span>
            </label>
            <div className="d-flex">
              <Field
                name="isprivate"
                label={LocaleStrings.course_form_course_listing_option1}
                component={this.renderFieldRadio}
                type="radio"
                value="0"
              />{" "}
              <Field
                name="isprivate"
                label={LocaleStrings.course_form_course_listing_option2}
                component={this.renderFieldRadio}
                type="radio"
                value="1"
              />
            </div>
          </div>
        </div>
        <Field
          name="courseteachers"
          label={LocaleStrings.course_form_label_course_instructor}
          placeholder={LocaleStrings.course_form_ph_course_instructor}
          component={this.renderAutoComplete}
          mandatory="false"
          isMulti={true}
          options={teachers}
          labelKey="name"
          valueKey="value"
          // value=''
        />
        <Field
          name="tagid"
          label={LocaleStrings.course_form_label_course_tags}
          placeholder={LocaleStrings.course_form_ph_course_tags}
          component={this.renderAutoComplete}
          mandatory="false"
          isMulti={true}
          options={tags}
          labelKey="name"
          valueKey="value"
          // value=''
        />
      </div>
    );
  }
}
